import { FlexLayout } from '@deity/falcon-ui';
import { FlowActionTypes, FlowContext } from 'contexts/FlowContext';
import type { FC } from 'react';
import { useContext } from 'react';
import ValidationErrorList from '../../ValidationErrorList';

const FlowErrorsPanel: FC = () => {
  const ctx = useContext(FlowContext);

  return (
    <FlexLayout>
      {ctx?.state.flowSummary && (
        <ValidationErrorList
          messages={ctx.state.flowSummary.messages}
          fields={{ component: true }}
          onClick={componentId => {
            ctx?.dispatch({
              type: FlowActionTypes.SELECT_COMPONENT,
              payload: { componentId }
            });
          }}
        />
      )}
    </FlexLayout>
  );
};

export default FlowErrorsPanel;
